import { render, staticRenderFns } from "./FinanceTabPromotions.vue?vue&type=template&id=e7184bee&scoped=true"
import script from "./FinanceTabPromotions.vue?vue&type=script&lang=js"
export * from "./FinanceTabPromotions.vue?vue&type=script&lang=js"
import style0 from "./FinanceTabPromotions.vue?vue&type=style&index=0&id=e7184bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7184bee",
  null
  
)

export default component.exports